import NoPermissionsPage from './NoPermisssionsPage'

export default NoPermissionsPage
